import { lazy } from 'react';
import AuthGuard from '../guards/AuthGuard';
import AdminGuard from '../guards/AdminGuard';

const DeviceEdit = lazy(() => import('../pages/admin/DeviceEdit'));

const Orders = lazy(() => import('../pages/admin/OrderList'));
const OffersManage = lazy(() => import('../pages/admin/OffersManage'));
const VouchersManage = lazy(() => import('../pages/admin/VouchersManage'));
const ReferralsManage = lazy(() => import('../pages/admin/ReferralsManage'));
const IncomeDashboard = lazy(() => import('../pages/admin/IncomeDashboard'));
const IoTDeviceManagement = lazy(() => import('../pages/admin/IoTDeviceManagement'));
const InstallerActionsPage = lazy(() => import('../pages/admin/InstallerActionsPage'));

const MqttClusterPage = lazy(() => import('../pages/admin/MqttClusterPage'));
const AppConfigPage = lazy(() => import('../pages/admin/AppConfigPage'));
const DtcManagementPage = lazy(() => import('../pages/admin/DtcManagementPage'));
const ObdSniffPage = lazy(() => import('../pages/admin/ObdSniffPage'));
const DeviceHealthPage = lazy(() => import('../pages/admin/DeviceHealthPage'));
const FirmwareUpdatePage = lazy(() => import('../pages/admin/FirmwareUpdatePage'));
const AssistantPage = lazy(() => import('../pages/admin/AssistantPage'));

const adminRoutes = {
  path: 'admin',
  children: [
    { path: 'device/:id', element: <AuthGuard><AdminGuard><DeviceEdit /></AdminGuard></AuthGuard> },
    { path: 'orders', element: <AuthGuard><AdminGuard><Orders /></AdminGuard></AuthGuard> },
    { path: 'offers', element: <AuthGuard><AdminGuard><OffersManage /></AdminGuard></AuthGuard> },
    { path: 'vouchers', element: <AuthGuard><AdminGuard><VouchersManage /></AdminGuard></AuthGuard> },
    { path: 'referrals', element: <AuthGuard><AdminGuard><ReferralsManage /></AdminGuard></AuthGuard> },

    { path: 'income', element: <AuthGuard><AdminGuard><IncomeDashboard /></AdminGuard></AuthGuard> },
    { path: 'iot-device-management', element: <AuthGuard><AdminGuard><IoTDeviceManagement /></AdminGuard></AuthGuard> },
    { path: 'installer-actions', element: <AuthGuard><AdminGuard><InstallerActionsPage /></AdminGuard></AuthGuard> },
    { path: 'mqtt', element: <AuthGuard><AdminGuard><MqttClusterPage /></AdminGuard></AuthGuard> },
    { path: 'app-config', element: <AuthGuard><AdminGuard><AppConfigPage /></AdminGuard></AuthGuard> },
    { path: 'device-health', element: <AuthGuard><AdminGuard><DeviceHealthPage /></AdminGuard></AuthGuard> },
    { path: 'dtc', element: <AuthGuard><AdminGuard><DtcManagementPage /></AdminGuard></AuthGuard> },
    { path: 'obd-sniff', element: <AuthGuard><AdminGuard><ObdSniffPage /></AdminGuard></AuthGuard> },
    { path: 'firmware', element: <AuthGuard><AdminGuard><FirmwareUpdatePage /></AdminGuard></AuthGuard> },
    { path: 'assistant', element: <AuthGuard><AdminGuard><AssistantPage /></AdminGuard></AuthGuard> },
  ],
};

export default adminRoutes;
